//人员
export default {
	GetChildDepartmentInfo: "/index.php/cqh/Department/GetChildDepartmentInfo", // 选择部门
	GetUsersByDeptId: "/index.php/cqh/Employeeext/GetUsersByDeptId", // 选择人员
	GetInfoByIds: "/index.php/cqh/Employeeext/GetInfoByIds", // 获取部门/人员详情
	GetAllChildUsers: '/index.php/cqh/Employeeext/GetAllChildUsers',//获取部门下的所有人员(包括子部门)
};
